module.exports = __webpack_public_path__ + "static/media/lead-magnet-landing-page-sample-template-1.b30448ec.jpg";